// @flow
import React from 'react';
import ChannelList from '@sendbird/uikit-react/ChannelList';
import { Flex, Text, Image, Button } from '@locus-taxy/neo-ui';
import Conversation from './Conversation';

import { useTranslation } from 'react-i18next';

const EmptyConversation = ({ openContactTab }) => {
    const { t } = useTranslation('liveView');
    return (
        <Flex
            flexDirection="column"
            justifyContent="flex-end"
            alignItems="center"
            mt="130px"
        >
            <Image src="img/motiontrack_new_conversation.svg" />
            <Text
                color="grey.500"
                fontSize={1}
                lineHeight={0}
                pt={6}
                pb={5}
                textAlign="center"
            >
                {t('riderManagerChat.noConversations')}
                <br />
                {t('riderManagerChat.pickContact')}
            </Text>
            <Button
                palette="primary"
                appearance="solid"
                onClick={openContactTab}
                size="small"
            >
                {t('riderManagerChat.startNewConversation')}
            </Button>
        </Flex>
    );
};

const Conversations = ({
    setSelectedProfile,
    openMessageWindow,
    openContactTab
}) => {
    const handleConversationCardClick = profile => {
        setSelectedProfile(profile);
        openMessageWindow();
    };

    const EmptyConversationState = () => (
        <EmptyConversation openContactTab={openContactTab} />
    );

    return (
        <ChannelList
            renderHeader={() => null}
            renderChannelPreview={({ channel }) => (
                <Conversation channel={channel} />
            )}
            renderPlaceHolderEmptyList={EmptyConversationState}
            onChannelSelect={channel =>
                handleConversationCardClick(channel?.url)
            }
            disableAutoSelect
        />
    );
};

export default Conversations;
